module.exports = __webpack_public_path__ + "img/checkmark.8b30f4f8.svg";